<script>
    import { user, view, change_attribute, send_data, send_images } from "../client.svelte.js";
    import {exhibit_URL} from "../core.js"
    import {sections_of, site_of, particips_of, advt_characters, sectTyp, sectTag, goto_page} from "./_Prepare.svelte";
    import Sidebar from "../elements/Sidebar.svelte";

    let exhibitsDialog = $state(), coverInput = $state()
    const noAdventure = {name: "", campaigne: "", region: "", places: "", season: "", teaser: "", cover: null, sites: {}, rewards: []}
    let advent = $derived(view.adventure ?? noAdventure)
    let tale = $derived(view.tale ?? {playeds: []})
    let teaserEdit = $state(false)
    let teaserInfo = $state(false)

    let sections = $derived((tale.playeds ?? []).map(sectID => user.sections.get(`${advent.ID}-${sectID}`)).map((sect, idx) => {
        const site = site_of(sect)
        const npcs = particips_of(advent, sect.SECT)
        const exhibits = user.exhibits.values().filter(img => img.advtID === advent.ID && img.sectID === sect.SECT).toArray()
        return {sect, num: idx + 1, site, npcs, exhibits,
                meta: [site?.name, npcs.length ? `${npcs.length} NSC` : null].filter(Boolean).join(" · ") ||
                      (exhibits.length ? `${exhibits.length} Bilder` : "")}
    }))
    let summary = $derived(
        Object.entries(Object.groupBy(sections, ({sect}) => sect.ZUB))
            .map(([typ, list]) => `${list.length} × ${sectTyp[typ] ?? typ}`)
            .join(" · ") )

    let tags = $derived([
        {icon: 'book', label: advent.campaigne}, {icon: 'compass', label: advent.region}, {icon: 'leaf', label: advent.season}
    ].filter(tag => tag.label))

    let cover = $derived((advent.cover) ? user.exhibits.get(advent.cover) : null)
    let exhibitGroups = $derived(
        Object.entries(Object.groupBy(
            user.exhibits.values().filter(img => img.advtID === view.adventure?.ID).toArray(),
            (img) => img.sectID ?? ""))
        .map(([sectKey, exhibits]) => {
            const entry = sections.find(({sect}) => sect.SECT === sectKey)
            return {label: (entry) ? `${entry.num} · ${entry.sect.name}` : "Abenteuer", num: entry?.num ?? 0, exhibits}
        })
        .sort((a, b) => a.num - b.num) )


    function open_section(sectID) {
        view.select_section(sectID)
        if (!game.ID)
            view.switch_layout('advt-section')
    }

    async function select_cover(exhibit) {
        exhibitsDialog.close()
        await send_data(`/adventure/${advent.ID}`, {cover: exhibit.ID}, 'PATCH')
    }

    async function upload_cover(e) {
        const imgfile = e.target.files[0]
        if (!imgfile)  return
        const params = {type: 'image', SECT: "", name: `cover`}
        await send_images([imgfile], params)
        console.log(`ADVENT: Upload image ${imgfile.name} as cover image to server.`)
    }

</script>


<!-------------------------------- HTML -------------------------------------->

<section id={view.layout.page} class="prepare-page">
	{#if !game.ID}
		<Sidebar items={[
			{id: 'cover', icon: 'image', label: "Titelbild", onclick: () => exhibitsDialog.showModal()},
			{id: 'teaser', icon: 'pen', label: "Einleitung", active: teaserEdit, onclick: () => teaserEdit = !teaserEdit} ]}/>
	{/if}

	<article class="page">
		<header class="pageHead">
			<span class="card-kicker">Abenteuer {advent.ID}</span>
			<input id="name" class="titleInput" value={advent.name} aria-label="Name des Abenteuers" disabled={!!game.ID}
			       onchange={change_attribute.bind(advent)}>
			{#if tags.length}
				<div class="tags">
					{#each tags as tag}
						<span class="tag neutral"><i class="fa icon-{tag.icon}"></i>{tag.label}</span>
					{/each}
				</div>
			{/if}
		</header>

		<div class="columns">

			<!-- left column: teaser and sequence of sections -->
			<div class="column">
				<fieldset class="card" data-help="teaser">
					<div class="cardHead">
						<h3 class="card-title">Einleitung</h3>
						<button class="textBtn muted" title="Was gehört in die Einleitung?" onclick={() => teaserInfo = !teaserInfo}>
							<i class="fa icon-info"></i>
						</button>
						{#if !game.ID}
							<button class="textBtn push" onclick={() => teaserEdit = !teaserEdit}>
								<i class="fa icon-{teaserEdit ? 'check' : 'pen'}"></i>{teaserEdit ? "fertig" : "bearbeiten"}
							</button>
						{/if}
					</div>
					{#if teaserInfo}
						<p class="card-meta hint">Die Einleitung sollte ein kurzer Text sein, der kurz das Setting des Abenteuers beschreibt ohne zu viel zu verraten.
							Fast so wie ein Klappentext bei einem Buch.</p>
					{/if}
					{#if teaserEdit}
						<div class="field">
							<textarea id="teaser" rows="9" value={advent.teaser ?? ""} onchange={change_attribute.bind(advent)}></textarea>
						</div>
						<span class="card-meta">{(advent.teaser ?? "").length} Zeichen</span>
					{:else}
						<p class="teaserText">{advent.teaser || "…"}</p>
					{/if}
				</fieldset>

				<fieldset class="card sequence" data-help="sequence">
					<div class="cardHead">
						<h3 class="card-title">Ablauf</h3>
						<span class="card-meta">{summary}</span>
						{#if !game.ID}
							<button class="textBtn push" onclick={() => goto_page('structure')}>
								Abschnitte bearbeiten<i class="fa icon-arrow-right"></i>
							</button>
						{/if}
					</div>
					{#each sections as entry (entry.num)}
						<button class="listRow sectRow" onclick={() => open_section(entry.sect.ID)}>
							<span class="num">{entry.num}</span>
							<span class="tag {sectTag[entry.sect.ZUB]}">{sectTyp[entry.sect.ZUB]}</span>
							<span class="ellipsis">{entry.sect.name}</span>
							<span class="card-meta">{entry.meta}</span>
						</button>
					{:else}
						<p class="empty">Das Abenteuer hat noch keine Abschnitte.</p>
					{/each}
				</fieldset>
			</div>

			<!-- right column: cover, general data and scope of the adventure -->
			<div class="column">
				<fieldset class="card" data-help="cover">
					<h3 class="card-title">Titelbild</h3>
					<button class="coverBox" title="Titelbild auswählen" disabled={!!game.ID} onclick={() => exhibitsDialog.showModal()}>
						{#if cover}
							<img src={exhibit_URL(cover)} alt={cover.title ?? advent.cover}>
						{:else}
							<span class="placeholder"><i class="fa icon-image"></i>Titelbild auswählen</span>
						{/if}
					</button>
					{#if !game.ID}
						<div class="button-row">
							<button class="button-secondary" onclick={() => exhibitsDialog.showModal()}><i class="fa icon-images"></i>Aus Bildern wählen</button>
							<button class="button-secondary" onclick={() => coverInput.click()}><i class="fa icon-upload"></i>Bild hochladen</button>
						</div>
					{/if}
				</fieldset>

				<fieldset class="card" disabled={!!game.ID} onchange={change_attribute.bind(advent)}>
					<h3 class="card-title">Allgemeine Daten</h3>
					<div class="fieldGrid">
						<div class="field"><label for="campaigne">Kampagne</label><input id="campaigne" value={advent.campaigne ?? ""}></div>
						<div class="field"><label for="region">Region</label><input id="region" value={advent.region ?? ""}></div>
						<div class="field"><label for="season">Jahreszeit</label><input id="season" value={advent.season ?? ""}></div>
						<div class="field"><label for="places">Orte</label><input id="places" value={advent.places ?? ""}></div>
					</div>
				</fieldset>

			</div>
		</div>
	</article>

	<input bind:this={coverInput} type=file accept=".jpg, .jpeg, .webp" onchange={upload_cover} />

	<dialog bind:this={exhibitsDialog} class="dlg exhibitsDialog" data-help="cover" onclick={(e) => {if (e.target === exhibitsDialog)  exhibitsDialog.close()}}>
		<div class="dlg-head">
			<h3>Bild auswählen</h3>
			<button class="btn-primary btn-primary-circle icon-upload" onclick={() => coverInput.click()}>Bild hochladen</button>
			<button class="dlg-close" title="Schließen" aria-label="Schließen" onclick={() => exhibitsDialog.close()}></button>
		</div>
		<div class="dlg-body">
			{#each exhibitGroups as group}
				<div class="group">
					<h3>{group.label}</h3>
					<div class="imageGrid">
						{#each group.exhibits as exhibit (exhibit.ID)}
							<button class="exhibit" class:selected={exhibit.ID === advent.cover} title={exhibit.ID} onclick={() => select_cover(exhibit)}>
								<img src={exhibit_URL(exhibit)} alt={exhibit.title ?? exhibit.ID}>
								<span>{exhibit.title}</span>
							</button>
						{/each}
					</div>
				</div>
			{:else}
				<p class="empty">Zu diesem Abenteuer gibt es noch keine Bilder. Lade ein Bild hoch oder füge den Abschnitten Bilder hinzu.</p>
			{/each}
		</div>
	</dialog>
</section>


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	h3
		margin: 0

	.hint
		max-width: 70ch
		line-height: 1.5

	.teaserText
		margin: 0
		padding: 0
		max-width: 68ch
		font-size: 15px
		line-height: 1.65
		color: colors.$grey-85
		white-space: pre-line
		text-wrap: pretty

	textarea
		font-size: 15px
		line-height: 1.55

	.sequence
		gap: 4px

	.sectRow
		display: grid
		grid-template-columns: 24px 64px minmax(0, 1fr) auto

		.num
			font-size: 12px
			color: colors.$grey-60
			text-align: right
			font-variant-numeric: tabular-nums

		.tag
			justify-content: center
			text-align: center

		.card-meta
			white-space: nowrap

	.coverBox
		display: grid
		place-items: center
		width: 100%
		aspect-ratio: 4 / 3
		margin: 0
		padding: 0
		border: 0
		border-radius: 8px
		overflow: hidden
		background: radial-gradient(ellipse at 30% 20%, colors.$grey-20, colors.$black 75%)
		cursor: pointer

		img
			width: 100%
			height: 100%
			object-fit: cover

		&:disabled
			cursor: default

	.placeholder
		display: flex
		flex-direction: column
		align-items: center
		gap: 8px
		color: colors.$grey-60
		font-size: 13px

		.fa
			font-size: 28px
			color: colors.$grey-30

	.scope
		gap: 2px
		padding: 10px 12px

	.scopeIcon
		font-size: 17px
		color: colors.$primary-100

	.scopeText
		flex: 1
		display: flex
		flex-direction: column
		gap: 2px
		min-width: 0

		.card-meta
			display: block

	.scopeCount
		font-size: 15px
		font-variant-numeric: tabular-nums
		color: colors.$grey-85

	.caret
		font-size: 12px
		color: colors.$grey-50

	input[type=file]
		display: none

	/* — dialog to select the cover from the exhibits of the adventure — */
	.exhibitsDialog
		width: min(760px, 90vw)

		.dlg-head .btn-primary
			margin-left: auto

		.dlg-body
			display: flex
			flex-direction: column
			gap: 18px

	.exhibit
		display: flex
		flex-direction: column
		gap: 6px
		margin: 0
		padding: 0
		border: 0
		background: none
		color: inherit
		font-size: 12px
		text-align: left
		cursor: pointer

		img
			width: 100%
			aspect-ratio: 1
			object-fit: cover
			border-radius: 8px
			border: 1px solid colors.$grey-30

		&:hover img, &.selected img
			border-color: colors.$primary-100

</style>
